import(/* webpackMode: "eager" */ "/app/apps/web/app/base.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.9_@babel+core@7.28.6_@opentelemetry+api@1.9.1_react-dom@19.2.3_react@19.2.3__react@19.2.3_sass@1.97.2/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/BackToTop/BackToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/GlobalFooter/GlobalFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/Header/AppHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/Header/B2BLanguageSwitcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/Header/Cart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/Header/EMICard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/Header/HeaderMoreMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/Header/HeaderNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/Header/Notifications.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/Header/Partner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/Header/Prime.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/Header/Search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/Header/SignIn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/header-footer/src/components/MobileHeader/BottomNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/shared-ui/src/components/BFLLink/BFLLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/sso/src/components/SSO.tsx");
